"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = require("../base/styled");
var _noop = _interopRequireDefault(require("lodash/noop"));
var _placeholderBanner = _interopRequireDefault(require("../../assets/png/placeholder-banner.png"));
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Banner = function Banner(_ref) {
  var photo = _ref.photo,
    label = _ref.label,
    editable = _ref.editable,
    onEdit = _ref.onEdit;
  return /*#__PURE__*/_react.default.createElement(_styled2.WrapperImage, null, !photo && label && /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true
  }, /*#__PURE__*/_react.default.createElement(_styled2.BannerLabel, null, label)), /*#__PURE__*/_react.default.createElement(_styled2.PhotoImage, {
    src: photo || _placeholderBanner.default
  }), editable && /*#__PURE__*/_react.default.createElement(_styled2.EditIcon, {
    onClick: onEdit
  }));
};
Banner.propTypes = {
  onEdit: _propTypes.default.func,
  photo: _propTypes.default.string,
  label: _propTypes.default.string,
  editable: _propTypes.default.bool
};
Banner.defaultProps = {
  photo: null,
  label: 'Your banner here',
  editable: false,
  onEdit: _noop.default
};
var _default = Banner;
exports.default = _default;